// Canonical activity category configuration — single source of truth.
// Used by both the server API (category filter SQL branching) and the
// web frontend (Select options, empty-state labels).
//
// eventTypes: event_type strings from the events table to include.
//   null → no event-type filter on the events branch.
//   For isTasksOnly categories, eventTypes are UNIONed in alongside task rows.
//   For events-only categories, eventTypes are the sole filter (no task rows).
//   "all": both branches unfiltered (eventTypes null, no isTasksOnly)
export const ACTIVITY_CATEGORIES = {
    all: {
        label: "All",
        emptyLabel: "activity",
        eventTypes: null,
    },
    observations: {
        label: "Behavior",
        emptyLabel: "behavior records",
        // Merged: observation_logged + behavior alerts (behavior_alert) + manual flags (alert_flag)
        // all three are directly tied behavioral signals and make more sense together in context.
        eventTypes: ["observation_logged", "behavior_alert", "alert_flag"],
    },
    status_changes: {
        label: "Status Changes",
        emptyLabel: "status changes",
        eventTypes: ["status_change", "adoption_level_change", "eval_status_change"],
    },
    transfers: {
        label: "Intakes & Outcomes",
        emptyLabel: "intakes, transfers or outcomes",
        // Includes initial arrivals and outcome reversals (previously orphaned event types).
        eventTypes: ["location_transfer", "re_intake", "outcome", "initial_intake", "outcome_cleared"],
    },
    tasks: {
        label: "Tasks & Meetings",
        emptyLabel: "tasks or meetings",
        // observation_added_to_task/meeting: recorded in the context of a task/meeting.
        // task_linked/meeting_linked: animal directly linked to a task or meeting.
        // All four are task-context events — previously task_linked and meeting_linked were orphaned.
        eventTypes: ["observation_added_to_task", "observation_added_to_meeting", "animal_added_to_task", "animal_added_to_meeting", "task_linked", "meeting_linked"],
        isTasksOnly: true,
    },
    files: {
        label: "Files",
        emptyLabel: "file uploads",
        eventTypes: ["file_upload"],
    },
};
// Derived constants — all computed from ACTIVITY_CATEGORIES so there is
// never a need to maintain separate lists.
export const ACTIVITY_CATEGORY_OPTIONS = Object.entries(ACTIVITY_CATEGORIES).map(([value, { label }]) => ({ value, label }));
export const ACTIVITY_CATEGORY_EMPTY_LABEL = Object.fromEntries(Object.entries(ACTIVITY_CATEGORIES).map(([value, { emptyLabel }]) => [value, emptyLabel]));
// Maps event-only category keys → their event type arrays.
// Keys "all" and "tasks" are intentionally absent.
export const ACTIVITY_CATEGORY_EVENT_TYPES = Object.fromEntries(Object.entries(ACTIVITY_CATEGORIES)
    .filter(([, { eventTypes, isTasksOnly }]) => eventTypes !== null && !isTasksOnly)
    .map(([value, { eventTypes }]) => [value, eventTypes]));
